import React from "react";
import { CarDetailState } from "./types";
import { Category } from "src/shared/services/interfacev2";

interface CategoryTabsProps {
  categories: Category[];
  activeCategoryId: string | null;
  onCategoryChange: (categoryId: string) => void;
  onShowAllProducts: () => void;
}

const CategoryTabs: React.FC<CategoryTabsProps> = React.memo(({ categories, activeCategoryId, onCategoryChange, onShowAllProducts }) => {
  const getButtonClasses = (isActive: boolean) =>
    `shrink-0 rounded-xl py-2.5 px-5 text-sm sm:text-base font-semibold transition-all duration-300 whitespace-nowrap border min-w-[110px] text-center ${
      isActive ? "bg-blue-600 text-white border-blue-600 shadow-md" : "bg-white text-gray-700 border-gray-200 hover:bg-blue-50 hover:border-blue-300 hover:text-blue-700"
    }`;

  const isAllActive = activeCategoryId === null;

  return (
    <div
      className="
          sticky top-0 z-30 bg-white
          border-b border-gray-200 shadow-sm
          px-3 sm:px-6 py-3
        "
    >
      <div className="flex gap-2 sm:gap-3 overflow-x-auto scrollbar-thin scrollbar-thumb-blue-200 scrollbar-track-gray-100">

        {/* Category Tabs */}
        {categories.map(({ _id, name }) => {
          const id = _id?.$oid ?? "";
          const isActive = activeCategoryId === id;

          return (
            <button key={id} onClick={() => onCategoryChange(id)} className={getButtonClasses(isActive)}>
              {name}
            </button>
          );
        })}
      </div>
    </div>
  );
});

export default CategoryTabs;
